import React, { useState,useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { dynamicUrl } from './Function';
import { Container,Row,Col,Card,Placeholder,Button } from 'react-bootstrap';
const Departments = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Pages,setPages]=useState([]);
    useEffect(()=>
    {
        const departmentPages = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"menu/subMenu/3");
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.departments.sd_id + "/sdImage")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.departments.sd_id + "/sdImageHi")
                                .then(upb => upb.json());
                            const fetch3 = fetch(global.config.API_URL + "menu/mainSubMenu/" + e.sp_id)
                                .then(sub => sub.json());
                            return Promise.all([fetch1, fetch2,fetch3])
                                .then(([upp, upb, sub]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb,
                                        sub
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].sdImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].sdImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                            result[i].submenu = el.sub;
                        });
                        setPages(result);
                    }).catch(error => 
                    {
                        console.error('Departments Image :', error);
                    });
                }
                if( global.config.IsPrint === true ) { console.info('Department Pages : Result',result); }
            } catch (error) 
            {
                console.error('Department Pages : Error', error.message);                
            }
            finally
            {
                setLoading(false);
            }
        };
        departmentPages();    
    },[])
    return (
        <Container className="py-5">
        {isLoading ? (
            <Row className="g-4">
            {[...Array(8)].map((_,index)=>(
                <Col md={3} key={index}>
                    <Card className='text-center w-100 h-100 shadow' data-aos="flip-up" data-aos-duration="1500">
                        <Placeholder xs={12} className="card-img-top" style={{minHeight:"180px"}} />
                        <Card.Body>
                            <Card.Title style={{minHeight:"50px"}}><Placeholder xs={10} /></Card.Title>
                            <Button className='btn btn-info rounded w-50'><Placeholder xs={12} /></Button>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
            </Row>
        ) : (
            <Row className="g-4">
            {Pages.map((sp, index)=>(
                <Col md={3} key={index}>
                    <Card className='text-center h-100 shadow' data-aos="flip-up" data-aos-duration="1500">
                        {appLanguage === 'hi' ? 
                            (
                                sp.sdImageHi 
                                ? <Card.Img variant="top" src={sp.sdImageHi} /> 
                                : <Card.Img variant="top" src={sp.sdImage} />
                            ) : (
                                <Card.Img variant="top" src={sp.sdImage} />
                            )
                        }                        
                        <Card.Body>
                            <Card.Title style={{minHeight:"50px"}}>{appLanguage === 'hi' ? sp.sp_name_hi || sp.sp_name : sp.sp_name}</Card.Title>
                            <NavLink to={dynamicUrl(sp)} className='btn btn-info rounded'>
                                {appLanguage === 'hi' ? "और पढ़ें" : "Read More"}
                            </NavLink>                            
                        </Card.Body>
                    </Card>
                </Col>
            ))}
            </Row>
        )}
        </Container>
    );    
}
export default Departments;